var map = {
	"./marking_controller.js": 21,
	"./modal_controller.js": 22,
	"./reorder_controller.js": 260,
	"./solution_reveal_controller.js": 23,
	"./table_wrap_controller.js": 24,
	"./upload_controller.js": 261,
	"./upload_file_controller.js": 65
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 20;